export type Timezone = {
    timezone: string;
    id: string;
    gmtOffset: number;
}

export const TIMEZONES = [
    { timezone: "Africa/Abidjan", gmtOffset: 0, id: "Africa/Abidjan" },
    { timezone: "Africa/Accra", gmtOffset: 0, id: "Africa/Accra" },
    { timezone: "Africa/Addis Ababa", gmtOffset: 3, id: "Africa/Addis Ababa" },
    { timezone: "Africa/Algiers", gmtOffset: 1, id: "Africa/Algiers" },
    { timezone: "Africa/Asmara", gmtOffset: 3, id: "Africa/Asmara" },
    { timezone: "Africa/Asmera", gmtOffset: 3, id: "Africa/Asmera" },
    { timezone: "Africa/Bamako", gmtOffset: 0, id: "Africa/Bamako" },
    { timezone: "Africa/Bangui", gmtOffset: 1, id: "Africa/Bangui" },
    { timezone: "Africa/Banjul", gmtOffset: 0, id: "Africa/Banjul" },
    { timezone: "Africa/Bissau", gmtOffset: 0, id: "Africa/Bissau" },
    { timezone: "Africa/Blantyre", gmtOffset: 2, id: "Africa/Blantyre" },
    { timezone: "Africa/Brazzaville", gmtOffset: 1, id: "Africa/Brazzaville" },
    { timezone: "Africa/Bujumbura", gmtOffset: 2, id: "Africa/Bujumbura" },
    { timezone: "Africa/Cairo", gmtOffset: 2, id: "Africa/Cairo" },
    { timezone: "Africa/Casablanca", gmtOffset: 1, id: "Africa/Casablanca" },
    { timezone: "Africa/Ceuta", gmtOffset: 1, id: "Africa/Ceuta" },
    { timezone: "Africa/Conakry", gmtOffset: 0, id: "Africa/Conakry" },
    { timezone: "Africa/Dakar", gmtOffset: 0, id: "Africa/Dakar" },
    { timezone: "Africa/Dar es Salaam", gmtOffset: 3, id: "Africa/Dar es Salaam" },
    { timezone: "Africa/Djibouti", gmtOffset: 3, id: "Africa/Djibouti" },
    { timezone: "Africa/Douala", gmtOffset: 1, id: "Africa/Douala" },
    { timezone: "Africa/El Aaiun", gmtOffset: 1, id: "Africa/El Aaiun" },
    { timezone: "Africa/Freetown", gmtOffset: 0, id: "Africa/Freetown" },
    { timezone: "Africa/Gaborone", gmtOffset: 2, id: "Africa/Gaborone" },
    { timezone: "Africa/Harare", gmtOffset: 2, id: "Africa/Harare" },
    { timezone: "Africa/Johannesburg", gmtOffset: 2, id: "Africa/Johannesburg" },
    { timezone: "Africa/Juba", gmtOffset: 2, id: "Africa/Juba" },
    { timezone: "Africa/Kampala", gmtOffset: 3, id: "Africa/Kampala" },
    { timezone: "Africa/Khartoum", gmtOffset: 2, id: "Africa/Khartoum" },
    { timezone: "Africa/Kigali", gmtOffset: 2, id: "Africa/Kigali" },
    { timezone: "Africa/Kinshasa", gmtOffset: 1, id: "Africa/Kinshasa" },
    { timezone: "Africa/Lagos", gmtOffset: 1, id: "Africa/Lagos" },
    { timezone: "Africa/Libreville", gmtOffset: 1, id: "Africa/Libreville" },
    { timezone: "Africa/Lome", gmtOffset: 0, id: "Africa/Lome" },
    { timezone: "Africa/Luanda", gmtOffset: 1, id: "Africa/Luanda" },
    { timezone: "Africa/Lubumbashi", gmtOffset: 2, id: "Africa/Lubumbashi" },
    { timezone: "Africa/Lusaka", gmtOffset: 2, id: "Africa/Lusaka" },
    { timezone: "Africa/Malabo", gmtOffset: 1, id: "Africa/Malabo" },
    { timezone: "Africa/Maputo", gmtOffset: 2, id: "Africa/Maputo" },
    { timezone: "Africa/Maseru", gmtOffset: 2, id: "Africa/Maseru" },
    { timezone: "Africa/Mbabane", gmtOffset: 2, id: "Africa/Mbabane" },
    { timezone: "Africa/Mogadishu", gmtOffset: 3, id: "Africa/Mogadishu" },
    { timezone: "Africa/Monrovia", gmtOffset: 0, id: "Africa/Monrovia" },
    { timezone: "Africa/Nairobi", gmtOffset: 3, id: "Africa/Nairobi" },
    { timezone: "Africa/Ndjamena", gmtOffset: 1, id: "Africa/Ndjamena" },
    { timezone: "Africa/Niamey", gmtOffset: 1, id: "Africa/Niamey" },
    { timezone: "Africa/Nouakchott", gmtOffset: 0, id: "Africa/Nouakchott" },
    { timezone: "Africa/Ouagadougou", gmtOffset: 0, id: "Africa/Ouagadougou" },
    { timezone: "Africa/Porto-Novo", gmtOffset: 1, id: "Africa/Porto-Novo" },
    { timezone: "Africa/Sao Tome", gmtOffset: 0, id: "Africa/Sao Tome" },
    { timezone: "Africa/Timbuktu", gmtOffset: 0, id: "Africa/Timbuktu" },
    { timezone: "Africa/Tripoli", gmtOffset: 2, id: "Africa/Tripoli" },
    { timezone: "Africa/Tunis", gmtOffset: 1, id: "Africa/Tunis" },
    { timezone: "Africa/Windhoek", gmtOffset: 2, id: "Africa/Windhoek" },
    { timezone: "America/Adak", gmtOffset: -10, id: "America/Adak" },
    { timezone: "America/Anchorage", gmtOffset: -9, id: "America/Anchorage" },
    { timezone: "America/Anguilla", gmtOffset: -4, id: "America/Anguilla" },
    { timezone: "America/Antigua", gmtOffset: -4, id: "America/Antigua" },
    { timezone: "America/Araguaina", gmtOffset: -3, id: "America/Araguaina" },
    { timezone: "America/Argentina/Buenos Aires", gmtOffset: -3, id: "America/Argentina/Buenos Aires" },
    { timezone: "America/Argentina/Catamarca", gmtOffset: -3, id: "America/Argentina/Catamarca" },
    { timezone: "America/Argentina/ComodRivadavia", gmtOffset: -3, id: "America/Argentina/ComodRivadavia" },
    { timezone: "America/Argentina/Cordoba", gmtOffset: -3, id: "America/Argentina/Cordoba" },
    { timezone: "America/Argentina/Jujuy", gmtOffset: -3, id: "America/Argentina/Jujuy" },
    { timezone: "America/Argentina/La Rioja", gmtOffset: -3, id: "America/Argentina/La Rioja" },
    { timezone: "America/Argentina/Mendoza", gmtOffset: -3, id: "America/Argentina/Mendoza" },
    { timezone: "America/Argentina/Rio Gallegos", gmtOffset: -3, id: "America/Argentina/Rio Gallegos" },
    { timezone: "America/Argentina/Salta", gmtOffset: -3, id: "America/Argentina/Salta" },
    { timezone: "America/Argentina/San Juan", gmtOffset: -3, id: "America/Argentina/San Juan" },
    { timezone: "America/Argentina/San Luis", gmtOffset: -3, id: "America/Argentina/San Luis" },
    { timezone: "America/Argentina/Tucuman", gmtOffset: -3, id: "America/Argentina/Tucuman" },
    { timezone: "America/Argentina/Ushuaia", gmtOffset: -3, id: "America/Argentina/Ushuaia" },
    { timezone: "America/Aruba", gmtOffset: -4, id: "America/Aruba" },
    { timezone: "America/Asuncion", gmtOffset: -3, id: "America/Asuncion" },
    { timezone: "America/Atikokan", gmtOffset: -5, id: "America/Atikokan" },
    { timezone: "America/Atka", gmtOffset: -10, id: "America/Atka" },
    { timezone: "America/Bahia", gmtOffset: -3, id: "America/Bahia" },
    { timezone: "America/Bahia Banderas", gmtOffset: -6, id: "America/Bahia Banderas" },
    { timezone: "America/Barbados", gmtOffset: -4, id: "America/Barbados" },
    { timezone: "America/Belem", gmtOffset: -3, id: "America/Belem" },
    { timezone: "America/Belize", gmtOffset: -6, id: "America/Belize" },
    { timezone: "America/Blanc-Sablon", gmtOffset: -4, id: "America/Blanc-Sablon" },
    { timezone: "America/Boa Vista", gmtOffset: -4, id: "America/Boa Vista" },
    { timezone: "America/Bogota", gmtOffset: -5, id: "America/Bogota" },
    { timezone: "America/Boise", gmtOffset: -7, id: "America/Boise" },
    { timezone: "America/Buenos Aires", gmtOffset: -3, id: "America/Buenos Aires" },
    { timezone: "America/Cambridge Bay", gmtOffset: -7, id: "America/Cambridge Bay" },
    { timezone: "America/Campo Grande", gmtOffset: -4, id: "America/Campo Grande" },
    { timezone: "America/Cancun", gmtOffset: -5, id: "America/Cancun" },
    { timezone: "America/Caracas", gmtOffset: -4, id: "America/Caracas" },
    { timezone: "America/Catamarca", gmtOffset: -3, id: "America/Catamarca" },
    { timezone: "America/Cayenne", gmtOffset: -3, id: "America/Cayenne" },
    { timezone: "America/Cayman", gmtOffset: -5, id: "America/Cayman" },
    { timezone: "America/Chicago", gmtOffset: -6, id: "America/Chicago" },
    { timezone: "America/Chihuahua", gmtOffset: -6, id: "America/Chihuahua" },
    { timezone: "America/Ciudad Juarez", gmtOffset: -7, id: "America/Ciudad Juarez" },
    { timezone: "America/Coral Harbour", gmtOffset: -5, id: "America/Coral Harbour" },
    { timezone: "America/Cordoba", gmtOffset: -3, id: "America/Cordoba" },
    { timezone: "America/Costa Rica", gmtOffset: -6, id: "America/Costa Rica" },
    { timezone: "America/Creston", gmtOffset: -7, id: "America/Creston" },
    { timezone: "America/Cuiaba", gmtOffset: -4, id: "America/Cuiaba" },
    { timezone: "America/Curacao", gmtOffset: -4, id: "America/Curacao" },
    { timezone: "America/Danmarkshavn", gmtOffset: 0, id: "America/Danmarkshavn" },
    { timezone: "America/Dawson", gmtOffset: -7, id: "America/Dawson" },
    { timezone: "America/Dawson Creek", gmtOffset: -7, id: "America/Dawson Creek" },
    { timezone: "America/Denver", gmtOffset: -7, id: "America/Denver" },
    { timezone: "America/Detroit", gmtOffset: -5, id: "America/Detroit" },
    { timezone: "America/Dominica", gmtOffset: -4, id: "America/Dominica" },
    { timezone: "America/Edmonton", gmtOffset: -7, id: "America/Edmonton" },
    { timezone: "America/Eirunepe", gmtOffset: -5, id: "America/Eirunepe" },
    { timezone: "America/El Salvador", gmtOffset: -6, id: "America/El Salvador" },
    { timezone: "America/Ensenada", gmtOffset: -8, id: "America/Ensenada" },
    { timezone: "America/Fort Nelson", gmtOffset: -7, id: "America/Fort Nelson" },
    { timezone: "America/Fort Wayne", gmtOffset: -5, id: "America/Fort Wayne" },
    { timezone: "America/Fortaleza", gmtOffset: -3, id: "America/Fortaleza" },
    { timezone: "America/Glace Bay", gmtOffset: -4, id: "America/Glace Bay" },
    { timezone: "America/Godthab", gmtOffset: -2, id: "America/Godthab" },
    { timezone: "America/Goose Bay", gmtOffset: -4, id: "America/Goose Bay" },
    { timezone: "America/Grand Turk", gmtOffset: -5, id: "America/Grand Turk" },
    { timezone: "America/Grenada", gmtOffset: -4, id: "America/Grenada" },
    { timezone: "America/Guadeloupe", gmtOffset: -4, id: "America/Guadeloupe" },
    { timezone: "America/Guatemala", gmtOffset: -6, id: "America/Guatemala" },
    { timezone: "America/Guayaquil", gmtOffset: -5, id: "America/Guayaquil" },
    { timezone: "America/Guyana", gmtOffset: -4, id: "America/Guyana" },
    { timezone: "America/Halifax", gmtOffset: -4, id: "America/Halifax" },
    { timezone: "America/Havana", gmtOffset: -5, id: "America/Havana" },
    { timezone: "America/Hermosillo", gmtOffset: -7, id: "America/Hermosillo" },
    { timezone: "America/Indiana/Indianapolis", gmtOffset: -5, id: "America/Indiana/Indianapolis" },
    { timezone: "America/Indiana/Knox", gmtOffset: -6, id: "America/Indiana/Knox" },
    { timezone: "America/Indiana/Marengo", gmtOffset: -5, id: "America/Indiana/Marengo" },
    { timezone: "America/Indiana/Petersburg", gmtOffset: -5, id: "America/Indiana/Petersburg" },
    { timezone: "America/Indiana/Tell City", gmtOffset: -6, id: "America/Indiana/Tell City" },
    { timezone: "America/Indiana/Vevay", gmtOffset: -5, id: "America/Indiana/Vevay" },
    { timezone: "America/Indiana/Vincennes", gmtOffset: -5, id: "America/Indiana/Vincennes" },
    { timezone: "America/Indiana/Winamac", gmtOffset: -5, id: "America/Indiana/Winamac" },
    { timezone: "America/Indianapolis", gmtOffset: -5, id: "America/Indianapolis" },
    { timezone: "America/Inuvik", gmtOffset: -7, id: "America/Inuvik" },
    { timezone: "America/Iqaluit", gmtOffset: -5, id: "America/Iqaluit" },
    { timezone: "America/Jamaica", gmtOffset: -5, id: "America/Jamaica" },
    { timezone: "America/Jujuy", gmtOffset: -3, id: "America/Jujuy" },
    { timezone: "America/Juneau", gmtOffset: -9, id: "America/Juneau" },
    { timezone: "America/Kentucky/Louisville", gmtOffset: -5, id: "America/Kentucky/Louisville" },
    { timezone: "America/Kentucky/Monticello", gmtOffset: -5, id: "America/Kentucky/Monticello" },
    { timezone: "America/Knox IN", gmtOffset: -6, id: "America/Knox IN" },
    { timezone: "America/Kralendijk", gmtOffset: -4, id: "America/Kralendijk" },
    { timezone: "America/La Paz", gmtOffset: -4, id: "America/La Paz" },
    { timezone: "America/Lima", gmtOffset: -5, id: "America/Lima" },
    { timezone: "America/Los Angeles", gmtOffset: -8, id: "America/Los Angeles" },
    { timezone: "America/Louisville", gmtOffset: -5, id: "America/Louisville" },
    { timezone: "America/Lower Princes", gmtOffset: -4, id: "America/Lower Princes" },
    { timezone: "America/Maceio", gmtOffset: -3, id: "America/Maceio" },
    { timezone: "America/Managua", gmtOffset: -6, id: "America/Managua" },
    { timezone: "America/Manaus", gmtOffset: -4, id: "America/Manaus" },
    { timezone: "America/Marigot", gmtOffset: -4, id: "America/Marigot" },
    { timezone: "America/Martinique", gmtOffset: -4, id: "America/Martinique" },
    { timezone: "America/Matamoros", gmtOffset: -6, id: "America/Matamoros" },
    { timezone: "America/Mazatlan", gmtOffset: -7, id: "America/Mazatlan" },
    { timezone: "America/Mendoza", gmtOffset: -3, id: "America/Mendoza" },
    { timezone: "America/Menominee", gmtOffset: -6, id: "America/Menominee" },
    { timezone: "America/Merida", gmtOffset: -6, id: "America/Merida" },
    { timezone: "America/Metlakatla", gmtOffset: -9, id: "America/Metlakatla" },
    { timezone: "America/Mexico City", gmtOffset: -6, id: "America/Mexico City" },
    { timezone: "America/Miquelon", gmtOffset: -3, id: "America/Miquelon" },
    { timezone: "America/Moncton", gmtOffset: -4, id: "America/Moncton" },
    { timezone: "America/Monterrey", gmtOffset: -6, id: "America/Monterrey" },
    { timezone: "America/Montevideo", gmtOffset: -3, id: "America/Montevideo" },
    { timezone: "America/Montreal", gmtOffset: -5, id: "America/Montreal" },
    { timezone: "America/Montserrat", gmtOffset: -4, id: "America/Montserrat" },
    { timezone: "America/Nassau", gmtOffset: -5, id: "America/Nassau" },
    { timezone: "America/New York", gmtOffset: -5, id: "America/New York" },
    { timezone: "America/Nipigon", gmtOffset: -5, id: "America/Nipigon" },
    { timezone: "America/Nome", gmtOffset: -9, id: "America/Nome" },
    { timezone: "America/Noronha", gmtOffset: -2, id: "America/Noronha" },
    { timezone: "America/North Dakota/Beulah", gmtOffset: -6, id: "America/North Dakota/Beulah" },
    { timezone: "America/North Dakota/Center", gmtOffset: -6, id: "America/North Dakota/Center" },
    { timezone: "America/North Dakota/New Salem", gmtOffset: -6, id: "America/North Dakota/New Salem" },
    { timezone: "America/Nuuk", gmtOffset: -2, id: "America/Nuuk" },
    { timezone: "America/Ojinaga", gmtOffset: -6, id: "America/Ojinaga" },
    { timezone: "America/Panama", gmtOffset: -5, id: "America/Panama" },
    { timezone: "America/Pangnirtung", gmtOffset: -5, id: "America/Pangnirtung" },
    { timezone: "America/Paramaribo", gmtOffset: -3, id: "America/Paramaribo" },
    { timezone: "America/Phoenix", gmtOffset: -7, id: "America/Phoenix" },
    { timezone: "America/Port-au-Prince", gmtOffset: -5, id: "America/Port-au-Prince" },
    { timezone: "America/Port of Spain", gmtOffset: -4, id: "America/Port of Spain" },
    { timezone: "America/Porto Acre", gmtOffset: -5, id: "America/Porto Acre" },
    { timezone: "America/Porto Velho", gmtOffset: -4, id: "America/Porto Velho" },
    { timezone: "America/Puerto Rico", gmtOffset: -4, id: "America/Puerto Rico" },
    { timezone: "America/Punta Arenas", gmtOffset: -3, id: "America/Punta Arenas" },
    { timezone: "America/Rainy River", gmtOffset: -6, id: "America/Rainy River" },
    { timezone: "America/Rankin Inlet", gmtOffset: -6, id: "America/Rankin Inlet" },
    { timezone: "America/Recife", gmtOffset: -3, id: "America/Recife" },
    { timezone: "America/Regina", gmtOffset: -6, id: "America/Regina" },
    { timezone: "America/Resolute", gmtOffset: -6, id: "America/Resolute" },
    { timezone: "America/Rio Branco", gmtOffset: -5, id: "America/Rio Branco" },
    { timezone: "America/Rosario", gmtOffset: -3, id: "America/Rosario" },
    { timezone: "America/Santa Isabel", gmtOffset: -8, id: "America/Santa Isabel" },
    { timezone: "America/Santarem", gmtOffset: -3, id: "America/Santarem" },
    { timezone: "America/Santiago", gmtOffset: -3, id: "America/Santiago" },
    { timezone: "America/Santo Domingo", gmtOffset: -4, id: "America/Santo Domingo" },
    { timezone: "America/Sao Paulo", gmtOffset: -3, id: "America/Sao Paulo" },
    { timezone: "America/Scoresbysund", gmtOffset: -2, id: "America/Scoresbysund" },
    { timezone: "America/Shiprock", gmtOffset: -7, id: "America/Shiprock" },
    { timezone: "America/Sitka", gmtOffset: -9, id: "America/Sitka" },
    { timezone: "America/St Barthelemy", gmtOffset: -4, id: "America/St Barthelemy" },
    { timezone: "America/St Johns", gmtOffset: -4, id: "America/St Johns" },
    { timezone: "America/St Kitts", gmtOffset: -4, id: "America/St Kitts" },
    { timezone: "America/St Lucia", gmtOffset: -4, id: "America/St Lucia" },
    { timezone: "America/St Thomas", gmtOffset: -4, id: "America/St Thomas" },
    { timezone: "America/St Vincent", gmtOffset: -4, id: "America/St Vincent" },
    { timezone: "America/Swift Current", gmtOffset: -6, id: "America/Swift Current" },
    { timezone: "America/Tegucigalpa", gmtOffset: -6, id: "America/Tegucigalpa" },
    { timezone: "America/Thule", gmtOffset: -4, id: "America/Thule" },
    { timezone: "America/Thunder Bay", gmtOffset: -5, id: "America/Thunder Bay" },
    { timezone: "America/Tijuana", gmtOffset: -8, id: "America/Tijuana" },
    { timezone: "America/Toronto", gmtOffset: -5, id: "America/Toronto" },
    { timezone: "America/Tortola", gmtOffset: -4, id: "America/Tortola" },
    { timezone: "America/Vancouver", gmtOffset: -8, id: "America/Vancouver" },
    { timezone: "America/Virgin", gmtOffset: -4, id: "America/Virgin" },
    { timezone: "America/Whitehorse", gmtOffset: -7, id: "America/Whitehorse" },
    { timezone: "America/Winnipeg", gmtOffset: -6, id: "America/Winnipeg" },
    { timezone: "America/Yakutat", gmtOffset: -9, id: "America/Yakutat" },
    { timezone: "America/Yellowknife", gmtOffset: -7, id: "America/Yellowknife" },
    { timezone: "Antarctica/Casey", gmtOffset: 8, id: "Antarctica/Casey" },
    { timezone: "Antarctica/Davis", gmtOffset: 7, id: "Antarctica/Davis" },
    { timezone: "Antarctica/DumontDUrville", gmtOffset: 10, id: "Antarctica/DumontDUrville" },
    { timezone: "Antarctica/Macquarie", gmtOffset: 11, id: "Antarctica/Macquarie" },
    { timezone: "Antarctica/Mawson", gmtOffset: 5, id: "Antarctica/Mawson" },
    { timezone: "Antarctica/McMurdo", gmtOffset: 13, id: "Antarctica/McMurdo" },
    { timezone: "Antarctica/Palmer", gmtOffset: -3, id: "Antarctica/Palmer" },
    { timezone: "Antarctica/Rothera", gmtOffset: -3, id: "Antarctica/Rothera" },
    { timezone: "Antarctica/South Pole", gmtOffset: 13, id: "Antarctica/South Pole" },
    { timezone: "Antarctica/Syowa", gmtOffset: 3, id: "Antarctica/Syowa" },
    { timezone: "Antarctica/Troll", gmtOffset: 0, id: "Antarctica/Troll" },
    { timezone: "Antarctica/Vostok", gmtOffset: 5, id: "Antarctica/Vostok" },
    { timezone: "Arctic/Longyearbyen", gmtOffset: 1, id: "Arctic/Longyearbyen" },
    { timezone: "Asia/Aden", gmtOffset: 3, id: "Asia/Aden" },
    { timezone: "Asia/Almaty", gmtOffset: 5, id: "Asia/Almaty" },
    { timezone: "Asia/Amman", gmtOffset: 3, id: "Asia/Amman" },
    { timezone: "Asia/Anadyr", gmtOffset: 12, id: "Asia/Anadyr" },
    { timezone: "Asia/Aqtau", gmtOffset: 5, id: "Asia/Aqtau" },
    { timezone: "Asia/Aqtobe", gmtOffset: 5, id: "Asia/Aqtobe" },
    { timezone: "Asia/Ashgabat", gmtOffset: 5, id: "Asia/Ashgabat" },
    { timezone: "Asia/Ashkhabad", gmtOffset: 5, id: "Asia/Ashkhabad" },
    { timezone: "Asia/Atyrau", gmtOffset: 5, id: "Asia/Atyrau" },
    { timezone: "Asia/Baghdad", gmtOffset: 3, id: "Asia/Baghdad" },
    { timezone: "Asia/Bahrain", gmtOffset: 3, id: "Asia/Bahrain" },
    { timezone: "Asia/Baku", gmtOffset: 4, id: "Asia/Baku" },
    { timezone: "Asia/Bangkok", gmtOffset: 7, id: "Asia/Bangkok" },
    { timezone: "Asia/Barnaul", gmtOffset: 7, id: "Asia/Barnaul" },
    { timezone: "Asia/Beirut", gmtOffset: 2, id: "Asia/Beirut" },
    { timezone: "Asia/Bishkek", gmtOffset: 6, id: "Asia/Bishkek" },
    { timezone: "Asia/Brunei", gmtOffset: 8, id: "Asia/Brunei" },
    { timezone: "Asia/Calcutta", gmtOffset: 6, id: "Asia/Calcutta" },
    { timezone: "Asia/Chita", gmtOffset: 9, id: "Asia/Chita" },
    { timezone: "Asia/Choibalsan", gmtOffset: 8, id: "Asia/Choibalsan" },
    { timezone: "Asia/Chongqing", gmtOffset: 8, id: "Asia/Chongqing" },
    { timezone: "Asia/Chungking", gmtOffset: 8, id: "Asia/Chungking" },
    { timezone: "Asia/Colombo", gmtOffset: 6, id: "Asia/Colombo" },
    { timezone: "Asia/Dacca", gmtOffset: 6, id: "Asia/Dacca" },
    { timezone: "Asia/Damascus", gmtOffset: 3, id: "Asia/Damascus" },
    { timezone: "Asia/Dhaka", gmtOffset: 6, id: "Asia/Dhaka" },
    { timezone: "Asia/Dili", gmtOffset: 9, id: "Asia/Dili" },
    { timezone: "Asia/Dubai", gmtOffset: 4, id: "Asia/Dubai" },
    { timezone: "Asia/Dushanbe", gmtOffset: 5, id: "Asia/Dushanbe" },
    { timezone: "Asia/Famagusta", gmtOffset: 2, id: "Asia/Famagusta" },
    { timezone: "Asia/Gaza", gmtOffset: 2, id: "Asia/Gaza" },
    { timezone: "Asia/Harbin", gmtOffset: 8, id: "Asia/Harbin" },
    { timezone: "Asia/Hebron", gmtOffset: 2, id: "Asia/Hebron" },
    { timezone: "Asia/Ho Chi Minh", gmtOffset: 7, id: "Asia/Ho Chi Minh" },
    { timezone: "Asia/Hong Kong", gmtOffset: 8, id: "Asia/Hong Kong" },
    { timezone: "Asia/Hovd", gmtOffset: 7, id: "Asia/Hovd" },
    { timezone: "Asia/Irkutsk", gmtOffset: 8, id: "Asia/Irkutsk" },
    { timezone: "Asia/Istanbul", gmtOffset: 3, id: "Asia/Istanbul" },
    { timezone: "Asia/Jakarta", gmtOffset: 7, id: "Asia/Jakarta" },
    { timezone: "Asia/Jayapura", gmtOffset: 9, id: "Asia/Jayapura" },
    { timezone: "Asia/Jerusalem", gmtOffset: 2, id: "Asia/Jerusalem" },
    { timezone: "Asia/Kabul", gmtOffset: 4, id: "Asia/Kabul" },
    { timezone: "Asia/Kamchatka", gmtOffset: 12, id: "Asia/Kamchatka" },
    { timezone: "Asia/Karachi", gmtOffset: 5, id: "Asia/Karachi" },
    { timezone: "Asia/Kashgar", gmtOffset: 6, id: "Asia/Kashgar" },
    { timezone: "Asia/Kathmandu", gmtOffset: 6, id: "Asia/Kathmandu" },
    { timezone: "Asia/Katmandu", gmtOffset: 6, id: "Asia/Katmandu" },
    { timezone: "Asia/Khandyga", gmtOffset: 9, id: "Asia/Khandyga" },
    { timezone: "Asia/Kolkata", gmtOffset: 6, id: "Asia/Kolkata" },
    { timezone: "Asia/Krasnoyarsk", gmtOffset: 7, id: "Asia/Krasnoyarsk" },
    { timezone: "Asia/Kuala Lumpur", gmtOffset: 8, id: "Asia/Kuala Lumpur" },
    { timezone: "Asia/Kuching", gmtOffset: 8, id: "Asia/Kuching" },
    { timezone: "Asia/Kuwait", gmtOffset: 3, id: "Asia/Kuwait" },
    { timezone: "Asia/Macao", gmtOffset: 8, id: "Asia/Macao" },
    { timezone: "Asia/Macau", gmtOffset: 8, id: "Asia/Macau" },
    { timezone: "Asia/Magadan", gmtOffset: 11, id: "Asia/Magadan" },
    { timezone: "Asia/Makassar", gmtOffset: 8, id: "Asia/Makassar" },
    { timezone: "Asia/Manila", gmtOffset: 8, id: "Asia/Manila" },
    { timezone: "Asia/Muscat", gmtOffset: 4, id: "Asia/Muscat" },
    { timezone: "Asia/Nicosia", gmtOffset: 2, id: "Asia/Nicosia" },
    { timezone: "Asia/Novokuznetsk", gmtOffset: 7, id: "Asia/Novokuznetsk" },
    { timezone: "Asia/Novosibirsk", gmtOffset: 7, id: "Asia/Novosibirsk" },
    { timezone: "Asia/Omsk", gmtOffset: 6, id: "Asia/Omsk" },
    { timezone: "Asia/Oral", gmtOffset: 5, id: "Asia/Oral" },
    { timezone: "Asia/Phnom Penh", gmtOffset: 7, id: "Asia/Phnom Penh" },
    { timezone: "Asia/Pontianak", gmtOffset: 7, id: "Asia/Pontianak" },
    { timezone: "Asia/Pyongyang", gmtOffset: 9, id: "Asia/Pyongyang" },
    { timezone: "Asia/Qatar", gmtOffset: 3, id: "Asia/Qatar" },
    { timezone: "Asia/Qostanay", gmtOffset: 5, id: "Asia/Qostanay" },
    { timezone: "Asia/Qyzylorda", gmtOffset: 5, id: "Asia/Qyzylorda" },
    { timezone: "Asia/Rangoon", gmtOffset: 6, id: "Asia/Rangoon" },
    { timezone: "Asia/Riyadh", gmtOffset: 3, id: "Asia/Riyadh" },
    { timezone: "Asia/Saigon", gmtOffset: 7, id: "Asia/Saigon" },
    { timezone: "Asia/Sakhalin", gmtOffset: 11, id: "Asia/Sakhalin" },
    { timezone: "Asia/Samarkand", gmtOffset: 5, id: "Asia/Samarkand" },
    { timezone: "Asia/Seoul", gmtOffset: 9, id: "Asia/Seoul" },
    { timezone: "Asia/Shanghai", gmtOffset: 8, id: "Asia/Shanghai" },
    { timezone: "Asia/Singapore", gmtOffset: 8, id: "Asia/Singapore" },
    { timezone: "Asia/Srednekolymsk", gmtOffset: 11, id: "Asia/Srednekolymsk" },
    { timezone: "Asia/Taipei", gmtOffset: 8, id: "Asia/Taipei" },
    { timezone: "Asia/Tashkent", gmtOffset: 5, id: "Asia/Tashkent" },
    { timezone: "Asia/Tbilisi", gmtOffset: 4, id: "Asia/Tbilisi" },
    { timezone: "Asia/Tehran", gmtOffset: 4, id: "Asia/Tehran" },
    { timezone: "Asia/Tel Aviv", gmtOffset: 2, id: "Asia/Tel Aviv" },
    { timezone: "Asia/Thimbu", gmtOffset: 6, id: "Asia/Thimbu" },
    { timezone: "Asia/Thimphu", gmtOffset: 6, id: "Asia/Thimphu" },
    { timezone: "Asia/Tokyo", gmtOffset: 9, id: "Asia/Tokyo" },
    { timezone: "Asia/Tomsk", gmtOffset: 7, id: "Asia/Tomsk" },
    { timezone: "Asia/Ujung Pandang", gmtOffset: 8, id: "Asia/Ujung Pandang" },
    { timezone: "Asia/Ulaanbaatar", gmtOffset: 8, id: "Asia/Ulaanbaatar" },
    { timezone: "Asia/Ulan Bator", gmtOffset: 8, id: "Asia/Ulan Bator" },
    { timezone: "Asia/Urumqi", gmtOffset: 6, id: "Asia/Urumqi" },
    { timezone: "Asia/Ust-Nera", gmtOffset: 10, id: "Asia/Ust-Nera" },
    { timezone: "Asia/Vientiane", gmtOffset: 7, id: "Asia/Vientiane" },
    { timezone: "Asia/Vladivostok", gmtOffset: 10, id: "Asia/Vladivostok" },
    { timezone: "Asia/Yakutsk", gmtOffset: 9, id: "Asia/Yakutsk" },
    { timezone: "Asia/Yangon", gmtOffset: 6, id: "Asia/Yangon" },
    { timezone: "Asia/Yekaterinburg", gmtOffset: 5, id: "Asia/Yekaterinburg" },
    { timezone: "Asia/Yerevan", gmtOffset: 4, id: "Asia/Yerevan" },
    { timezone: "Atlantic/Azores", gmtOffset: -1, id: "Atlantic/Azores" },
    { timezone: "Atlantic/Bermuda", gmtOffset: -4, id: "Atlantic/Bermuda" },
    { timezone: "Atlantic/Canary", gmtOffset: 0, id: "Atlantic/Canary" },
    { timezone: "Atlantic/Cape Verde", gmtOffset: -1, id: "Atlantic/Cape Verde" },
    { timezone: "Atlantic/Faeroe", gmtOffset: 0, id: "Atlantic/Faeroe" },
    { timezone: "Atlantic/Faroe", gmtOffset: 0, id: "Atlantic/Faroe" },
    { timezone: "Atlantic/Jan Mayen", gmtOffset: 1, id: "Atlantic/Jan Mayen" },
    { timezone: "Atlantic/Madeira", gmtOffset: 0, id: "Atlantic/Madeira" },
    { timezone: "Atlantic/Reykjavik", gmtOffset: 0, id: "Atlantic/Reykjavik" },
    { timezone: "Atlantic/South Georgia", gmtOffset: -2, id: "Atlantic/South Georgia" },
    { timezone: "Atlantic/St Helena", gmtOffset: 0, id: "Atlantic/St Helena" },
    { timezone: "Atlantic/Stanley", gmtOffset: -3, id: "Atlantic/Stanley" },
    { timezone: "Australia/ACT", gmtOffset: 11, id: "Australia/ACT" },
    { timezone: "Australia/Adelaide", gmtOffset: 10, id: "Australia/Adelaide" },
    { timezone: "Australia/Brisbane", gmtOffset: 10, id: "Australia/Brisbane" },
    { timezone: "Australia/Broken Hill", gmtOffset: 10, id: "Australia/Broken Hill" },
    { timezone: "Australia/Canberra", gmtOffset: 11, id: "Australia/Canberra" },
    { timezone: "Australia/Currie", gmtOffset: 11, id: "Australia/Currie" },
    { timezone: "Australia/Darwin", gmtOffset: 10, id: "Australia/Darwin" },
    { timezone: "Australia/Eucla", gmtOffset: 9, id: "Australia/Eucla" },
    { timezone: "Australia/Hobart", gmtOffset: 11, id: "Australia/Hobart" },
    { timezone: "Australia/LHI", gmtOffset: 11, id: "Australia/LHI" },
    { timezone: "Australia/Lindeman", gmtOffset: 10, id: "Australia/Lindeman" },
    { timezone: "Australia/Lord Howe", gmtOffset: 11, id: "Australia/Lord Howe" },
    { timezone: "Australia/Melbourne", gmtOffset: 11, id: "Australia/Melbourne" },
    { timezone: "Australia/NSW", gmtOffset: 11, id: "Australia/NSW" },
    { timezone: "Australia/North", gmtOffset: 10, id: "Australia/North" },
    { timezone: "Australia/Perth", gmtOffset: 8, id: "Australia/Perth" },
    { timezone: "Australia/Queensland", gmtOffset: 10, id: "Australia/Queensland" },
    { timezone: "Australia/South", gmtOffset: 10, id: "Australia/South" },
    { timezone: "Australia/Sydney", gmtOffset: 11, id: "Australia/Sydney" },
    { timezone: "Australia/Tasmania", gmtOffset: 11, id: "Australia/Tasmania" },
    { timezone: "Australia/Victoria", gmtOffset: 11, id: "Australia/Victoria" },
    { timezone: "Australia/West", gmtOffset: 8, id: "Australia/West" },
    { timezone: "Australia/Yancowinna", gmtOffset: 10, id: "Australia/Yancowinna" },
    { timezone: "Brazil/Acre", gmtOffset: -5, id: "Brazil/Acre" },
    { timezone: "Brazil/DeNoronha", gmtOffset: -2, id: "Brazil/DeNoronha" },
    { timezone: "Brazil/East", gmtOffset: -3, id: "Brazil/East" },
    { timezone: "Brazil/West", gmtOffset: -4, id: "Brazil/West" },
    { timezone: "CET", gmtOffset: 1, id: "CET" },
    { timezone: "CST6CDT", gmtOffset: -6, id: "CST6CDT" },
    { timezone: "Canada/Atlantic", gmtOffset: -4, id: "Canada/Atlantic" },
    { timezone: "Canada/Central", gmtOffset: -6, id: "Canada/Central" },
    { timezone: "Canada/Eastern", gmtOffset: -5, id: "Canada/Eastern" },
    { timezone: "Canada/Mountain", gmtOffset: -7, id: "Canada/Mountain" },
    { timezone: "Canada/Newfoundland", gmtOffset: -4, id: "Canada/Newfoundland" },
    { timezone: "Canada/Pacific", gmtOffset: -8, id: "Canada/Pacific" },
    { timezone: "Canada/Saskatchewan", gmtOffset: -6, id: "Canada/Saskatchewan" },
    { timezone: "Canada/Yukon", gmtOffset: -7, id: "Canada/Yukon" },
    { timezone: "Chile/Continental", gmtOffset: -3, id: "Chile/Continental" },
    { timezone: "Chile/EasterIsland", gmtOffset: -5, id: "Chile/EasterIsland" },
    { timezone: "Cuba", gmtOffset: -5, id: "Cuba" },
    { timezone: "EET", gmtOffset: 2, id: "EET" },
    { timezone: "EST", gmtOffset: -5, id: "EST" },
    { timezone: "EST5EDT", gmtOffset: -5, id: "EST5EDT" },
    { timezone: "Egypt", gmtOffset: 2, id: "Egypt" },
    { timezone: "Eire", gmtOffset: 0, id: "Eire" },
    { timezone: "GMT", gmtOffset: 0, id: "Etc/GMT" },
    { timezone: "GMT+0", gmtOffset: 0, id: "Etc/GMT+0" },
    { timezone: "GMT+1", gmtOffset: -1, id: "Etc/GMT+1" },
    { timezone: "GMT+10", gmtOffset: -10, id: "Etc/GMT+10" },
    { timezone: "GMT+11", gmtOffset: -11, id: "Etc/GMT+11" },
    { timezone: "GMT+12", gmtOffset: -12, id: "Etc/GMT+12" },
    { timezone: "GMT+2", gmtOffset: -2, id: "Etc/GMT+2" },
    { timezone: "GMT+3", gmtOffset: -3, id: "Etc/GMT+3" },
    { timezone: "GMT+4", gmtOffset: -4, id: "Etc/GMT+4" },
    { timezone: "GMT+5", gmtOffset: -5, id: "Etc/GMT+5" },
    { timezone: "GMT+6", gmtOffset: -6, id: "Etc/GMT+6" },
    { timezone: "GMT+7", gmtOffset: -7, id: "Etc/GMT+7" },
    { timezone: "GMT+8", gmtOffset: -8, id: "Etc/GMT+8" },
    { timezone: "GMT+9", gmtOffset: -9, id: "Etc/GMT+9" },
    { timezone: "GMT-0", gmtOffset: 0, id: "Etc/GMT-0" },
    { timezone: "GMT-1", gmtOffset: 1, id: "Etc/GMT-1" },
    { timezone: "GMT-10", gmtOffset: 10, id: "Etc/GMT-10" },
    { timezone: "GMT-11", gmtOffset: 11, id: "Etc/GMT-11" },
    { timezone: "GMT-12", gmtOffset: 12, id: "Etc/GMT-12" },
    { timezone: "GMT-13", gmtOffset: 13, id: "Etc/GMT-13" },
    { timezone: "GMT-14", gmtOffset: 14, id: "Etc/GMT-14" },
    { timezone: "GMT-2", gmtOffset: 2, id: "Etc/GMT-2" },
    { timezone: "GMT-3", gmtOffset: 3, id: "Etc/GMT-3" },
    { timezone: "GMT-4", gmtOffset: 4, id: "Etc/GMT-4" },
    { timezone: "GMT-5", gmtOffset: 5, id: "Etc/GMT-5" },
    { timezone: "GMT-6", gmtOffset: 6, id: "Etc/GMT-6" },
    { timezone: "GMT-7", gmtOffset: 7, id: "Etc/GMT-7" },
    { timezone: "GMT-8", gmtOffset: 8, id: "Etc/GMT-8" },
    { timezone: "GMT-9", gmtOffset: 9, id: "Etc/GMT-9" },
    { timezone: "GMT0", gmtOffset: 0, id: "Etc/GMT0" },
    { timezone: "Greenwich", gmtOffset: 0, id: "Etc/Greenwich" },
    { timezone: "UCT", gmtOffset: 0, id: "Etc/UCT" },
    { timezone: "UTC", gmtOffset: 0, id: "Etc/UTC" },
    { timezone: "Universal", gmtOffset: 0, id: "Etc/Universal" },
    { timezone: "Zulu", gmtOffset: 0, id: "Etc/Zulu" },
    { timezone: "Europe/Amsterdam", gmtOffset: 1, id: "Europe/Amsterdam" },
    { timezone: "Europe/Andorra", gmtOffset: 1, id: "Europe/Andorra" },
    { timezone: "Europe/Astrakhan", gmtOffset: 4, id: "Europe/Astrakhan" },
    { timezone: "Europe/Athens", gmtOffset: 2, id: "Europe/Athens" },
    { timezone: "Europe/Belfast", gmtOffset: 0, id: "Europe/Belfast" },
    { timezone: "Europe/Belgrade", gmtOffset: 1, id: "Europe/Belgrade" },
    { timezone: "Europe/Berlin", gmtOffset: 1, id: "Europe/Berlin" },
    { timezone: "Europe/Bratislava", gmtOffset: 1, id: "Europe/Bratislava" },
    { timezone: "Europe/Brussels", gmtOffset: 1, id: "Europe/Brussels" },
    { timezone: "Europe/Bucharest", gmtOffset: 2, id: "Europe/Bucharest" },
    { timezone: "Europe/Budapest", gmtOffset: 1, id: "Europe/Budapest" },
    { timezone: "Europe/Busingen", gmtOffset: 1, id: "Europe/Busingen" },
    { timezone: "Europe/Chisinau", gmtOffset: 2, id: "Europe/Chisinau" },
    { timezone: "Europe/Copenhagen", gmtOffset: 1, id: "Europe/Copenhagen" },
    { timezone: "Europe/Dublin", gmtOffset: 0, id: "Europe/Dublin" },
    { timezone: "Europe/Gibraltar", gmtOffset: 1, id: "Europe/Gibraltar" },
    { timezone: "Europe/Guernsey", gmtOffset: 0, id: "Europe/Guernsey" },
    { timezone: "Europe/Helsinki", gmtOffset: 2, id: "Europe/Helsinki" },
    { timezone: "Europe/Isle of Man", gmtOffset: 0, id: "Europe/Isle of Man" },
    { timezone: "Europe/Istanbul", gmtOffset: 3, id: "Europe/Istanbul" },
    { timezone: "Europe/Jersey", gmtOffset: 0, id: "Europe/Jersey" },
    { timezone: "Europe/Kaliningrad", gmtOffset: 2, id: "Europe/Kaliningrad" },
    { timezone: "Europe/Kiev", gmtOffset: 2, id: "Europe/Kiev" },
    { timezone: "Europe/Kirov", gmtOffset: 3, id: "Europe/Kirov" },
    { timezone: "Europe/Kyiv", gmtOffset: 2, id: "Europe/Kyiv" },
    { timezone: "Europe/Lisbon", gmtOffset: 0, id: "Europe/Lisbon" },
    { timezone: "Europe/Ljubljana", gmtOffset: 1, id: "Europe/Ljubljana" },
    { timezone: "Europe/London", gmtOffset: 0, id: "Europe/London" },
    { timezone: "Europe/Luxembourg", gmtOffset: 1, id: "Europe/Luxembourg" },
    { timezone: "Europe/Madrid", gmtOffset: 1, id: "Europe/Madrid" },
    { timezone: "Europe/Malta", gmtOffset: 1, id: "Europe/Malta" },
    { timezone: "Europe/Mariehamn", gmtOffset: 2, id: "Europe/Mariehamn" },
    { timezone: "Europe/Minsk", gmtOffset: 3, id: "Europe/Minsk" },
    { timezone: "Europe/Monaco", gmtOffset: 1, id: "Europe/Monaco" },
    { timezone: "Europe/Moscow", gmtOffset: 3, id: "Europe/Moscow" },
    { timezone: "Europe/Nicosia", gmtOffset: 2, id: "Europe/Nicosia" },
    { timezone: "Europe/Oslo", gmtOffset: 1, id: "Europe/Oslo" },
    { timezone: "Europe/Paris", gmtOffset: 1, id: "Europe/Paris" },
    { timezone: "Europe/Podgorica", gmtOffset: 1, id: "Europe/Podgorica" },
    { timezone: "Europe/Prague", gmtOffset: 1, id: "Europe/Prague" },
    { timezone: "Europe/Riga", gmtOffset: 2, id: "Europe/Riga" },
    { timezone: "Europe/Rome", gmtOffset: 1, id: "Europe/Rome" },
    { timezone: "Europe/Samara", gmtOffset: 4, id: "Europe/Samara" },
    { timezone: "Europe/San Marino", gmtOffset: 1, id: "Europe/San Marino" },
    { timezone: "Europe/Sarajevo", gmtOffset: 1, id: "Europe/Sarajevo" },
    { timezone: "Europe/Saratov", gmtOffset: 4, id: "Europe/Saratov" },
    { timezone: "Europe/Simferopol", gmtOffset: 3, id: "Europe/Simferopol" },
    { timezone: "Europe/Skopje", gmtOffset: 1, id: "Europe/Skopje" },
    { timezone: "Europe/Sofia", gmtOffset: 2, id: "Europe/Sofia" },
    { timezone: "Europe/Stockholm", gmtOffset: 1, id: "Europe/Stockholm" },
    { timezone: "Europe/Tallinn", gmtOffset: 2, id: "Europe/Tallinn" },
    { timezone: "Europe/Tirane", gmtOffset: 1, id: "Europe/Tirane" },
    { timezone: "Europe/Tiraspol", gmtOffset: 2, id: "Europe/Tiraspol" },
    { timezone: "Europe/Ulyanovsk", gmtOffset: 4, id: "Europe/Ulyanovsk" },
    { timezone: "Europe/Uzhgorod", gmtOffset: 2, id: "Europe/Uzhgorod" },
    { timezone: "Europe/Vaduz", gmtOffset: 1, id: "Europe/Vaduz" },
    { timezone: "Europe/Vatican", gmtOffset: 1, id: "Europe/Vatican" },
    { timezone: "Europe/Vienna", gmtOffset: 1, id: "Europe/Vienna" },
    { timezone: "Europe/Vilnius", gmtOffset: 2, id: "Europe/Vilnius" },
    { timezone: "Europe/Volgograd", gmtOffset: 3, id: "Europe/Volgograd" },
    { timezone: "Europe/Warsaw", gmtOffset: 1, id: "Europe/Warsaw" },
    { timezone: "Europe/Zagreb", gmtOffset: 1, id: "Europe/Zagreb" },
    { timezone: "Europe/Zaporozhye", gmtOffset: 2, id: "Europe/Zaporozhye" },
    { timezone: "Europe/Zurich", gmtOffset: 1, id: "Europe/Zurich" },
    { timezone: "GB", gmtOffset: 0, id: "GB" },
    { timezone: "GB-Eire", gmtOffset: 0, id: "GB-Eire" },
    { timezone: "GMT", gmtOffset: 0, id: "GMT" },
    { timezone: "Greenwich", gmtOffset: 0, id: "Greenwich" },
    { timezone: "HST", gmtOffset: -10, id: "HST" },
    { timezone: "Hongkong", gmtOffset: 8, id: "Hongkong" },
    { timezone: "Iceland", gmtOffset: 0, id: "Iceland" },
    { timezone: "Indian/Antananarivo", gmtOffset: 3, id: "Indian/Antananarivo" },
    { timezone: "Indian/Chagos", gmtOffset: 6, id: "Indian/Chagos" },
    { timezone: "Indian/Christmas", gmtOffset: 7, id: "Indian/Christmas" },
    { timezone: "Indian/Cocos", gmtOffset: 6, id: "Indian/Cocos" },
    { timezone: "Indian/Comoro", gmtOffset: 3, id: "Indian/Comoro" },
    { timezone: "Indian/Kerguelen", gmtOffset: 5, id: "Indian/Kerguelen" },
    { timezone: "Indian/Mahe", gmtOffset: 4, id: "Indian/Mahe" },
    { timezone: "Indian/Maldives", gmtOffset: 5, id: "Indian/Maldives" },
    { timezone: "Indian/Mauritius", gmtOffset: 4, id: "Indian/Mauritius" },
    { timezone: "Indian/Mayotte", gmtOffset: 3, id: "Indian/Mayotte" },
    { timezone: "Indian/Reunion", gmtOffset: 4, id: "Indian/Reunion" },
    { timezone: "Iran", gmtOffset: 4, id: "Iran" },
    { timezone: "Israel", gmtOffset: 2, id: "Israel" },
    { timezone: "Jamaica", gmtOffset: -5, id: "Jamaica" },
    { timezone: "Japan", gmtOffset: 9, id: "Japan" },
    { timezone: "Kwajalein", gmtOffset: 12, id: "Kwajalein" },
    { timezone: "Libya", gmtOffset: 2, id: "Libya" },
    { timezone: "MET", gmtOffset: 1, id: "MET" },
    { timezone: "MST", gmtOffset: -7, id: "MST" },
    { timezone: "MST7MDT", gmtOffset: -7, id: "MST7MDT" },
    { timezone: "Mexico/BajaNorte", gmtOffset: -8, id: "Mexico/BajaNorte" },
    { timezone: "Mexico/BajaSur", gmtOffset: -7, id: "Mexico/BajaSur" },
    { timezone: "Mexico/General", gmtOffset: -6, id: "Mexico/General" },
    { timezone: "NZ", gmtOffset: 13, id: "NZ" },
    { timezone: "NZ-CHAT", gmtOffset: 14, id: "NZ-CHAT" },
    { timezone: "Navajo", gmtOffset: -7, id: "Navajo" },
    { timezone: "PRC", gmtOffset: 8, id: "PRC" },
    { timezone: "Pacific/Apia", gmtOffset: 13, id: "Pacific/Apia" },
    { timezone: "Pacific/Auckland", gmtOffset: 13, id: "Pacific/Auckland" },
    { timezone: "Pacific/Bougainville", gmtOffset: 11, id: "Pacific/Bougainville" },
    { timezone: "Pacific/Chatham", gmtOffset: 14, id: "Pacific/Chatham" },
    { timezone: "Pacific/Chuuk", gmtOffset: 10, id: "Pacific/Chuuk" },
    { timezone: "Pacific/Easter", gmtOffset: -5, id: "Pacific/Easter" },
    { timezone: "Pacific/Efate", gmtOffset: 11, id: "Pacific/Efate" },
    { timezone: "Pacific/Enderbury", gmtOffset: 13, id: "Pacific/Enderbury" },
    { timezone: "Pacific/Fakaofo", gmtOffset: 13, id: "Pacific/Fakaofo" },
    { timezone: "Pacific/Fiji", gmtOffset: 12, id: "Pacific/Fiji" },
    { timezone: "Pacific/Funafuti", gmtOffset: 12, id: "Pacific/Funafuti" },
    { timezone: "Pacific/Galapagos", gmtOffset: -6, id: "Pacific/Galapagos" },
    { timezone: "Pacific/Gambier", gmtOffset: -9, id: "Pacific/Gambier" },
    { timezone: "Pacific/Guadalcanal", gmtOffset: 11, id: "Pacific/Guadalcanal" },
    { timezone: "Pacific/Guam", gmtOffset: 10, id: "Pacific/Guam" },
    { timezone: "Pacific/Honolulu", gmtOffset: -10, id: "Pacific/Honolulu" },
    { timezone: "Pacific/Johnston", gmtOffset: -10, id: "Pacific/Johnston" },
    { timezone: "Pacific/Kanton", gmtOffset: 13, id: "Pacific/Kanton" },
    { timezone: "Pacific/Kiritimati", gmtOffset: 14, id: "Pacific/Kiritimati" },
    { timezone: "Pacific/Kosrae", gmtOffset: 11, id: "Pacific/Kosrae" },
    { timezone: "Pacific/Kwajalein", gmtOffset: 12, id: "Pacific/Kwajalein" },
    { timezone: "Pacific/Majuro", gmtOffset: 12, id: "Pacific/Majuro" },
    { timezone: "Pacific/Marquesas", gmtOffset: -10, id: "Pacific/Marquesas" },
    { timezone: "Pacific/Midway", gmtOffset: -11, id: "Pacific/Midway" },
    { timezone: "Pacific/Nauru", gmtOffset: 12, id: "Pacific/Nauru" },
    { timezone: "Pacific/Niue", gmtOffset: -11, id: "Pacific/Niue" },
    { timezone: "Pacific/Norfolk", gmtOffset: 12, id: "Pacific/Norfolk" },
    { timezone: "Pacific/Noumea", gmtOffset: 11, id: "Pacific/Noumea" },
    { timezone: "Pacific/Pago Pago", gmtOffset: -11, id: "Pacific/Pago Pago" },
    { timezone: "Pacific/Palau", gmtOffset: 9, id: "Pacific/Palau" },
    { timezone: "Pacific/Pitcairn", gmtOffset: -8, id: "Pacific/Pitcairn" },
    { timezone: "Pacific/Pohnpei", gmtOffset: 11, id: "Pacific/Pohnpei" },
    { timezone: "Pacific/Ponape", gmtOffset: 11, id: "Pacific/Ponape" },
    { timezone: "Pacific/Port Moresby", gmtOffset: 10, id: "Pacific/Port Moresby" },
    { timezone: "Pacific/Rarotonga", gmtOffset: -10, id: "Pacific/Rarotonga" },
    { timezone: "Pacific/Saipan", gmtOffset: 10, id: "Pacific/Saipan" },
    { timezone: "Pacific/Samoa", gmtOffset: -11, id: "Pacific/Samoa" },
    { timezone: "Pacific/Tahiti", gmtOffset: -10, id: "Pacific/Tahiti" },
    { timezone: "Pacific/Tarawa", gmtOffset: 12, id: "Pacific/Tarawa" },
    { timezone: "Pacific/Tongatapu", gmtOffset: 13, id: "Pacific/Tongatapu" },
    { timezone: "Pacific/Truk", gmtOffset: 10, id: "Pacific/Truk" },
    { timezone: "Pacific/Wake", gmtOffset: 12, id: "Pacific/Wake" },
    { timezone: "Pacific/Wallis", gmtOffset: 12, id: "Pacific/Wallis" },
    { timezone: "Pacific/Yap", gmtOffset: 10, id: "Pacific/Yap" },
    { timezone: "Poland", gmtOffset: 1, id: "Poland" },
    { timezone: "Portugal", gmtOffset: 0, id: "Portugal" },
    { timezone: "ROC", gmtOffset: 8, id: "ROC" },
    { timezone: "ROK", gmtOffset: 9, id: "ROK" },
    { timezone: "Singapore", gmtOffset: 8, id: "Singapore" },
    { timezone: "Turkey", gmtOffset: 3, id: "Turkey" },
    { timezone: "UCT", gmtOffset: 0, id: "UCT" },
    { timezone: "US/Alaska", gmtOffset: -9, id: "US/Alaska" },
    { timezone: "US/Aleutian", gmtOffset: -10, id: "US/Aleutian" },
    { timezone: "US/Arizona", gmtOffset: -7, id: "US/Arizona" },
    { timezone: "US/Central", gmtOffset: -6, id: "US/Central" },
    { timezone: "US/East-Indiana", gmtOffset: -5, id: "US/East-Indiana" },
    { timezone: "US/Eastern", gmtOffset: -5, id: "US/Eastern" },
    { timezone: "US/Hawaii", gmtOffset: -10, id: "US/Hawaii" },
    { timezone: "US/Indiana-Starke", gmtOffset: -6, id: "US/Indiana-Starke" },
    { timezone: "US/Michigan", gmtOffset: -5, id: "US/Michigan" },
    { timezone: "US/Mountain", gmtOffset: -7, id: "US/Mountain" },
    { timezone: "US/Pacific", gmtOffset: -8, id: "US/Pacific" },
    { timezone: "US/Samoa", gmtOffset: -11, id: "US/Samoa" },
    { timezone: "UTC", gmtOffset: 0, id: "UTC" },
    { timezone: "Universal", gmtOffset: 0, id: "Universal" },
    { timezone: "WET", gmtOffset: 0, id: "WET" },
    { timezone: "Zulu", gmtOffset: 0, id: "Zulu" },
];
